import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { Account } from 'src/app/models/AccountModel';
import { ResultFilter, PlatformApiService, Results } from 'src/app/services/platform-api.service';
import { SessionService } from 'src/app/services/session.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';
import { ScanTarget } from 'src/app/models/ScanTargetModel';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';

@Component({
  selector: 'cw-ci-automate-scan-target-list',
  templateUrl: './automate-scan-target-list.component.html',
  styleUrls: []
})
export class AutomateScanTargetListComponent implements OnInit {

  @Input() parentAccount: Account;
  @Input() account: Account;
  accountList: Results<Account>;
  mappedAccounts = [];
  @ViewChild(DataTableComponent, { static: true }) scanResultsDataTable: DataTableComponent;

  @Output() stateChange: EventEmitter<any> = new EventEmitter();

  targetsList: ScanTarget[];
  isCompany = false;
  constructor(private _platformApi: PlatformApiService, public sessionService: SessionService, public dialog: MatDialog) { }

  ngOnInit() {
    if (!this.account){
      this.account = this.sessionService.getCurrentAccount();
    }
    this._platformApi.getMappedAutomateAccounts(this.account.id).subscribe(accounts => {
      for (const accs of accounts.results){
        this.mappedAccounts.push(accs.accountName);
      }
    })
  }

  integrate(event?) {
    this.stateChange.emit({ state: 'ACCOUNT_AUTOMATE_INTEGRATE' });
  }

  isSelectable(scan) {
    return true;
  }

  refresh(){
    this.scanResultsDataTable.executeLoadItems();
  }

  loadTargets(filter: ResultFilter) {
    let targetsListObservable;
    if (this.parentAccount) {
      targetsListObservable = this._platformApi.getAccountScanTargets(this.parentAccount.id, this.account.id, filter);
    } else if (!this.parentAccount && this.account){
      targetsListObservable = this._platformApi.getScanTargets(this.account.id, filter);
      this.isCompany = true;
    } else {
      targetsListObservable = this._platformApi.getAccountScanTargets(this.account.id, undefined, filter);
    }

    targetsListObservable.subscribe(results => {
      this.targetsList = results;
      console.log(results);
    })

  }

  selectTarget(selectedTarget: ScanTarget) {
    this.stateChange.emit({state:'SELECT_SCAN_TARGET', item:selectedTarget});
  }

  scanTarget(event?) {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptTitle: 'Execute Vulnerability Scan',
        promptMessage: [
          'Running a vulnerability scan may take 10 minutes or more and may cause a degradation in performance on the computer being scanned. Do you want to execute the scan?'
        ],
        closeLabel: 'No',
        buttons: [{label:'Yes', value:true, color:'primary'}],
        height: 'auto'
      }
    });
    dialogRef.afterClosed().subscribe(executeScan => {
      if (executeScan) {
        let parentAcctId;
        let subAcctId;
        if (this.parentAccount) {
          parentAcctId = this.parentAccount.id;
          subAcctId = this.account.id;
        } else {
          parentAcctId = this.account.id;
        }

        this._platformApi.executeScan(parentAcctId, subAcctId, event.id, 380, event.externalId).subscribe(res => {
          const errDialog = this.dialog.open(ConfirmationComponent, {
            panelClass: 'flush-dialog',
            data: {
              promptTitle: 'Running',
              promptMessage: [
                'The scan is currently running. Check back soon to access the results.'
              ],
              showClose: false,
              height: 'auto'
            }
          });
        }, err => {
          const errDialog = this.dialog.open(ConfirmationComponent, {
            panelClass: 'flush-dialog',
            data: {
              promptTitle: 'Error',
              promptMessage: [
                'An error was encountered running the scan.',
                JSON.stringify(err, null, 2)
              ],
              showClose: false,
              height: 'auto'
            }
          });
        })
      }
    });
  }
}
